import { css } from '@emotion/react'
import styled from '@emotion/styled'

import Input from '@src/components/inputs/Input'

type TrackingNumProps = {
	trackingNo?: string
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
	onClick: () => void
}

const TrackingNum = ({ trackingNo, onChange, onClick }: TrackingNumProps) => {
	const existTrackingNo = !!trackingNo
	return (
		<Block>
			{trackingNo ? (
				<TrackingNumTxt>{trackingNo}</TrackingNumTxt>
			) : (
				<Input css={inputStyle} wrapperStyle={inputWrapperStyle} onChange={onChange} />
			)}
			<button type="button" css={btnStyle(existTrackingNo)} onClick={onClick}>
				{existTrackingNo ? '수정' : '저장'}
			</button>
		</Block>
	)
}

const Block = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`

const TrackingNumTxt = styled.span`
	font-size: 1.2rem;
	font-weight: 4000;
	line-height: 3.1rem;
	text-decoration: underline;
	text-underline-position: under;
	color: #000;
	height: 2.75rem;
	margin: 1rem 0;
`

const inputWrapperStyle = css`
	justify-content: center;
`

const inputStyle = css`
	width: 10rem;
`

const btnStyle = (isExist: boolean) => css`
	border: ${isExist ? '1px solid #92959E' : '1px solid #FFCF19'};
	border-radius: 0.6rem;
	background-color: ${isExist ? '#fff' : '#FFCF19'};
	padding: 0.3rem 0.8rem;
	font-size: 1.2rem;
`

export default TrackingNum
